
import * as Sentry from "@sentry/react";

export const initSentry = () => {
  const dsn = "https://1ea766de45ba3aff0d361d73dcde48f2@o4509128698953728.ingest.us.sentry.io/4509550434123776";
  
  console.log("🔧 Initializing Sentry with console logging integration...");
  console.log("DSN:", dsn);
  
  try {
    Sentry.init({
      dsn: dsn,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
        // Official console logging integration
        Sentry.consoleLoggingIntegration({ 
          levels: ["log", "warn", "error"] 
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0,
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      // Enable logs to be sent to Sentry
      enableLogs: true,
      environment: import.meta.env.MODE,
    });
    
    console.log("✅ Sentry initialized with console logging integration!");
  } catch (error) {
    console.error("❌ Failed to initialize Sentry:", error);
  }
};

export { Sentry };
